import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../shared/providers/base-provider';
import { ShareNotifier } from './share-notifier';
import { ShareState } from './share-state';

@Injectable()
export class ShareProvider extends BaseProvider<ShareNotifier, ShareState> {
  constructor() {
    super(ShareNotifier);
  }
}
